<template>
  <div>
    <div class="video-container">
    <div class="level-wrapper" key="fade">
      <h3>视频分类：</h3>
      <ul class="level-content">
        <li
          class="level"
          @click="levelIndex = index"
          :class="{active:index===levelIndex}"
          v-for="(item,index) in courseType"
          :key="index"
        >{{item}}</li>
      </ul>
    </div>
    <div class="course-container">
      <ul class="course-wrapper">
        <li
          class="course"
          v-for="course in courseList"
          @click="enterCourse(course)"
          :key="course.courseId"
        >
          <div style="position:relative">
            <img :src="course.avatar" />
          </div>
          <h3 class="title ellipsis">{{course.titleCn}}</h3>
          <h4 class="sub_title ellipsis">{{course.titleEn}}</h4>
        </li>
        <li class="empty" v-for="(item,index) in new Array(10)" :key="index"></li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
import { Row, Col } from "element-ui";
import axios from "axios";
import defaultAvatar from "../assets/image/avatar.png";

export default {
  data() {
    return {
      nickname: "",
      avatar: "",
      levelIndex: 0,
      courseType: ["全部"],
      showIndex: 0,
      courseList: []
    };
  },
  components: {
    ElRow: Row,
    ElCol: Col
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.nickname = userInfo.nickname;
    this.avatar = userInfo.avatar;

    this.getCourse();
  },
  watch: {
    levelIndex(val) {
      if (val === 0) return this.courseList = this.allCourses;
      this.courseList = this.result[val - 1].courseData
      // switch (val) {
      //   case 0:
      //     this.courseList = this.allCourses;
      //     break;
      //   case 1:
      //     this.courseList = this.result[0].courseData;
      //     break;
      //   case 2:
      //     this.courseList = this.result[1].courseData;
      //     break;
      //   case 3:
      //     this.courseList = this.result[2].courseData;
      //     break;
      //   default:
      // }
    }
  },
  methods: {
    enterCourse(course) {
      let title = encodeURIComponent(course.titleEn);
      // console.log(this.$router.resolve({name:'video',params:{id:course.courseId || 123}}))
      window.open(`#/video/player?t=${title}&id=${course.courseId}`);
    },
    getAvatar(avatar) {
      return avatar ? avatar : defaultAvatar;
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/login");
    },
    getCourse() {
      axios
        .get("/v1/video/courses")
        .then(res => {
          let { result } = res;
          result.forEach(item => {
            this.courseType.push(item.level);
          });
          this.result = result.map(item => {
            // let courseData = item.courseData
            item.courseData = item.courseData.filter(course => {
              return course.paidStatus === 1;
            });
            return item;
          });
          // this.courseList = this.allCourses = [
          //   ...result[0].courseData,
          //   ...result[1].courseData,
          //   ...result[2].courseData
          // ];
          this.courseList = this.allCourses = result.reduce((pre, cur) => [...pre, ...cur.courseData], [])
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang='scss' scoped>
.video-container {
    width: 80%;
    margin: 0 auto;
    min-height: 500px;
    background-color: #fff;
    padding: 24px 16px 50px;
    border-radius: 10px;
    box-shadow: 0 6px 10px 0 rgba(54, 52, 104, 0.15);
    margin-top: 50px;
  }
.level-wrapper {
  height: 58px;
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  font-size: 16px;
  // color: $color-title;
  padding-left: 42px;
  // @include prefix(box-sizing, border-box);
  h3 {
    font-size: 16px;
    margin-right: 30px;
    width: 94px;
    text-align: right;
  }
  .level-content {
    display: flex;
    .level {
      font-size: 16px;
      margin-right: 60px;
      cursor: pointer;
      &.active {
        color: #38b5ef;
        font-weight: bold;
      }
      &:hover {
        color: #38b5ef;
      }
    }
  }
}
.course-container {
  margin-top: 30px;
  .course-wrapper {
    text-align: center;
    .empty {
      width: 212px;
      margin-right: 15px;
      display: inline-block;
    }
    .course {
      line-height: 14px;
      width: 202px;
      height: 190px;
      padding: 6px 5px 0;
      font-size: 0;
      display: inline-block;
      margin-bottom: 25px;
      margin-right: 15px;
      cursor: pointer;
      background-color: #fff;
      text-align: left;
      box-shadow: 3px 2px 6px 0px rgba(40, 198, 255, 0.25),
        -4px 0px 4px 0px rgba(40, 198, 255, 0.25);
      transition: transform 0.3s;
      border-radius: 10px;

      &.fade-enter-active {
        transition: opacity 0.3s;
      }
      &.fade-enter {
        opacity: 0;
      }
      &.fade-leave-active {
        display: none;
      }
      &:hover {
        box-shadow: 3px 2px 12px 0px rgba(40, 198, 255, 0.55),
          -4px 0px 12px 0px rgba(40, 198, 255, 0.55);

        transition: transform 0.3s;
        transform: scale(1.1);
      }
      img {
        // width: 192px;
        width:100%;
        height: 118px;
        border-radius: 4px;
      }
      div div img {
        width: 26px;
        height: 33px;
        margin-top: 75px;
        margin-left: 152px;
      }
      .title {
        font-size: 15px;
        margin-top: 4px;
        line-height: 1.5;
        height: 23px;
      }
      .sub_title {
        font-size: 13px;
        margin-top: 5px;
        color: #c3c3c9;
      }
      .ellipsis {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .tip {
        font-size: 12px;
        margin-top: 3px;
        color: #c3c3c9;
      }
    }
  }
}

@media screen and (min-width: 751px) and(max-width:1280px){
  .level-wrapper {
    height: auto;
    padding: 10px 5px;
    align-items: flex-start;
    line-height: 2;
    h3 {
      font-size: 15px;
      margin-right: 15px;
      white-space: nowrap;
    }
    .level-content {
      flex-wrap: wrap;
      .level {
        font-size: 15px;
        margin-right: 15px;
      }
    }
  }
}

@media screen and (max-width: 751px) {
  .level-wrapper {
    height: auto;
    padding: 10px 5px;
    align-items: flex-start;
    line-height: 2;
    h3 {
      font-size: 13px;
      margin-right: 10px;
      white-space: nowrap;
    }
    .level-content {
      flex-wrap: wrap;
      .level {
        font-size: 13px;
        margin-right: 10px;
      }
    }
  }
  .course-container {
    margin-top: 15px;
    .course-wrapper {
      text-align: center;
      .empty {
        width: 45%;
        margin-right: 2%;
      }
      .course {
        line-height: 14px;
        width: 45%;
        height: auto;
        padding: 6px 5px 5px;
        box-sizing: border-box;
        margin: 0 2% 3.5% 0;
        border-radius: 8px;
        img {
          width: 192px;
          height: 118px;

          width: 100%;
          height: auto;
          border-radius: 4px;
        }
        .title {
          font-size: 12px;
          margin-top: 0;
          line-height: 1.2;
          height: auto;
        }
        .sub_title {
          font-size: 11px;
          line-height: 1.2;
          margin-top: 3px;
          opacity: 1;
          font-weight: 300;
        }
      }
    }
  }
}
</style>
